import { CarsType } from '@/typings/common';
import { ApplicationModalType } from '@/components/modals/DetailedCarModal/DetailedCarModal';

export const INITIAL_FORM_VALUES = {
  type: 'new' as CarsType,
  id: '0',
  dealer: '',
  creditAmount: '',
  myPrice: '',
  myCarBrand: '',
  myCarModel: '',
  myCarYear: '',
  name: '',
  phone: '',
};

export function getInitialOptions(
  typeCar: CarsType,
  typeApplicationModal: ApplicationModalType,
  hideCreditAndTradeIn?: boolean
) {
  const baseFormOptions = [
    { value: 1, label: 'Хочу в кредит', checked: false },
    { value: 2, label: 'Хочу в Trade-in', checked: false },
  ];
  const creditTradeOptions = hideCreditAndTradeIn ? [] : baseFormOptions;

  return typeCar === 'new'
    ? creditTradeOptions
    : typeApplicationModal === 'CUSTOM_PRICE'
    ? [...creditTradeOptions, { value: 3, label: 'Своя цена', checked: true }]
    : creditTradeOptions;
}
